import type { AppSchemaDto } from "src/app/features/ApplicationSchema/types/AppSchemaDto";
import type { AppSchemaEntity } from "src/app/features/ApplicationSchema/types/AppSchemaEntity";
import { getAssignedDataGroup } from "../../../../../core/router/auth/SecurityManager";

export const AppSchemaEntityToDto = (appSchemaModel: AppSchemaEntity): AppSchemaDto => {
    const dataGroup = getAssignedDataGroup();
    const dataGroupCode = dataGroup?.code;
    const { version, appSchema } = appSchemaModel;
    return {
        appSchema: JSON.stringify(appSchema),
        dataGroupCode: String(dataGroupCode),
        version,
    };
};
